<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Cihazlar">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span>
                <strong>Not:</strong>
                Havalimanlarında bulunan ürünleri ekleyip çıkarabilirsiniz...</span
              >
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Havalimanları">
            <b-row>
              <b-col md="12">
                <b-form-group label="Hava Limanları" label-for="airports">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Hava Limanları"
                  >
                    <v-select
                      id="airports"
                      v-model="selectedAirport"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="airports"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Ürünler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>GÖRSEL</th>
                    <th>ÜRÜN ADI</th>
                    <th>STOK</th>
                  </thead>
                  <draggable
                    v-model="products"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr
                      v-for="extendedProduct in extendedProducts"
                      :key="extendedProduct.id"
                    >
                      <td>{{ extendedProduct.id }}</td>
                      <td>
                        <b-img :src="extendedProduct.productImage" width="32" />
                      </td>
                      <td>{{ extendedProduct.name }}</td>
                      <td class="text-center">
                        <b-form-checkbox
                          v-model="extendedProduct.inStock"
                          class="custom-control-primary"
                        >
                          Stokta Var
                        </b-form-checkbox>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>GÖRSEL</th>
                    <th>ÜRÜN ADI</th>
                    <th>STOK</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BPagination,
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BButtonGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
  BBadge,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import vSelect from "vue-select";
import draggable from "vuedraggable";
import Ripple from "vue-ripple-directive";
import { Endpoints } from "@core/endpoints/endpoints";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const endpoints = new Endpoints();

export default {
  components: {
    BPagination,
    BBadge,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BButtonGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      airports: [],
      products: [],
      languages: [],
      selectedAirport: null,
      airportProducts: [],
      extendedProducts: [],
      stockedProducts: [],
      userData: JSON.parse(localStorage.getItem("userData")),
      airportIds: [],
      spinner: false,
    };
  },
  watch: {
    selectedAirport: function (val) {
      this.getAirportProductsById(val.id);
    },
  },
  methods: {
    getProducts() {
      endpoints
        .getProducts(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.products = [...data.response];
          this.products.forEach((element) => {
            this.extendedProducts.push({
              id: element.id,
              name: element.name,
              productImage: element.images.productImage,
              inStock: false,
            });
          });
          this.getAllAirports();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
          this.getProducts();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllAirports(page) {
      endpoints
        .getAllAirports(page, this.$i18n.locale, () => {})
        .then((data) => {
          this.airports = [...data.response];

          if (this.userData.airportIds.length > 0) {
            this.airports = this.airports.filter((item) =>
              this.userData.airportIds.includes(item.id)
            );
            this.selectedAirport = this.airports[0];
          } else {
            this.airports = [...data.response];
            this.selectedAirport = this.airports[0];
          }
          this.getAirportProductsById(this.selectedAirport.id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAirportProductsById(id) {
      endpoints
        .getAirportProductsById(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.airportProducts = [...data.response];
          this.extendedProducts.forEach((element) => {
            element.inStock = this.airportProducts.some(
              (item) => item.productId === element.id
            );
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText() {
      this.$swal({
        title: "Kayıt?",
        text: "Havalimanı stoklarını güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          this.stockedProducts = [];
          this.extendedProducts.forEach((element) => {
            this.stockedProducts.push({
              productId: element.id,

              inStock: element.inStock,
            });
          });
          endpoints
            .postAirportProduct(
              {
                airportId: this.selectedAirport.id,
                data: this.stockedProducts,
              },
              this.$i18n.locale,
              () => {}
            )
            .then((data) => {
              this.spinner = false;

              if (!data.status) {
                this.$swal({
                  icon: "error",
                  title: "Hata!",
                  text: "Beklenmeyen bir hata oluştu.",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {});
              } else {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Havalimanı stokları güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  this.spinner = false;

                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {},
  },
  mounted() {
    this.getLanguages();
  },
  computed: {},
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
